import React, { useEffect } from 'react';
import { profileData } from '../data/mock';
import { Mail, MapPin, Linkedin, Github } from 'lucide-react';
import { Label } from './primitives';

// X (Twitter) icon component
const XIcon = ({ size = 24, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    className={className}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Contact = () => {
  useEffect(() => {
    // Initialize Cal.com inline embed
    if (window.Cal) {
      window.Cal("inline", {
        elementOrSelector: "#cal-inline-embed",
        calLink: "shashank-ectr0u/15min",
        layout: "month_view",
        config: {
          theme: "light"
        }
      });
      
      window.Cal("ui", {
        theme: "light",
        styles: { branding: { brandColor: "#14140F" } },
        hideEventTypeDetails: false,
        layout: "month_view"
      });
    }
  }, []);

  return (
    <section id="contact" className="py-16 sm:py-24 bg-cream scroll-mt-20">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        {/* Section Header */}
        <Label className="mb-3">Say hello</Label>
        <h2 className="text-2xl sm:text-4xl font-bold text-ink tracking-[-0.02em]">
          I'm building again. Let's talk.
        </h2>

        <p className="mt-3 mb-8 text-sm sm:text-base text-ink-soft leading-relaxed max-w-2xl">
          Happy to talk about GTM, creator marketing, AI tools for small
          businesses, or what I'm building next. Grab a slot below, or just
          email me.
        </p>

        {/* Cal.com Inline Embed */}
        <div className="bg-paper border-[1.5px] border-ink rounded-xl shadow-hard overflow-hidden mb-12">
          <div 
            id="cal-inline-embed" 
            style={{ width: '100%', height: '100%', minHeight: '650px', overflow: 'auto' }}
          />
        </div>

        {/* Contact Info Row - No boxes */}
        <div className="flex flex-wrap items-center gap-x-8 gap-y-4">
          {/* Email */}
          <a
            href={`mailto:${profileData.email}`}
            className="flex items-center gap-2.5 text-sm text-ink-soft hover:text-ink transition-colors group"
          >
            <Mail size={17} className="text-subtle group-hover:text-flag transition-colors" />
            <span className="font-medium">{profileData.email}</span>
          </a>

          {/* Separator */}
          <span className="hidden md:block w-1 h-1 bg-rule rounded-full" />

          {/* Location */}
          <div className="flex items-center gap-2.5 text-sm text-ink-soft">
            <MapPin size={17} className="text-subtle" />
            <span className="font-medium">{profileData.location}</span>
          </div>

          {/* Separator */}
          <span className="hidden md:block w-1 h-1 bg-rule rounded-full" />

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href={profileData.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="text-subtle hover:text-ink transition-colors"
              title="LinkedIn"
            >
              <Linkedin size={18} />
            </a>
            <a
              href={profileData.social.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="text-subtle hover:text-ink transition-colors"
              title="X (Twitter)"
            >
              <XIcon size={18} />
            </a>
            <a
              href={profileData.social.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-subtle hover:text-ink transition-colors"
              title="GitHub"
            >
              <Github size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
